import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Formik } from 'formik';
import './styles.css';
import AptitudeTestContentLoader from '../../../../components/AptitudeTestContentLoader';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicInput from '../../../../components/BasicInput';
import BasicSection from '../../../../components/BasicSection';
import CheckboxOrRadioGroup from '../../../../components/CheckboxOrRadioGroup';
import PanelContainer from '../../../../components/PanelContainer';
import AptitudeTestFormTimer from './components/AptitudeTestFormTimer';
import {AptitudeTestFormValidationSchema} from './validate';

const ANSWER_TYPE = {
  CHECKBOX: 'checkbox',
  TEXT: 'text',
};

const AptitudeTestForm = props => {
  const {
    timestamp,
    html = '',
    text,
    type,
    options,
    onSubmit,
    onTimeExpire,
  } = props;

  const markup = useMemo(
    () => ({
      __html: html,
    }),
    [html]
  );

  return (
    <Formik
      initialValues={{ answer: '' }}
      enableReinitialize={true}
      validationSchema={AptitudeTestFormValidationSchema}
      onSubmit={onSubmit}
      render={({ handleSubmit, handleChange, values, isSubmitting }) =>
        isSubmitting ? (
          <>
            <AptitudeTestContentLoader />
          </>
        ) : (
          <>
            <PanelContainer
              styles={{ marginBottom: '10px', paddingTop: '35px' }}
            >
              <BasicSection
                title="GoBuyside Aptitude Test"
                renderHeaderBlock={
                  <AptitudeTestFormTimer
                    startOn={timestamp}
                    onExpire={onTimeExpire}
                  />
                }
              >
                <div
                  className="aptitude-test-item"
                  dangerouslySetInnerHTML={markup}
                />
              </BasicSection>
            </PanelContainer>
            <PanelContainer
              styles={{ marginBottom: '10px', paddingTop: '35px' }}
            >
              {text && (
                <div
                  className="aptitude-test-form__block"
                  style={{ fontWeight: '600' }}
                >
                  {text}
                </div>
              )}
              <form
                onSubmit={handleSubmit}
                className="form__content form__content--aptitude"
                style={{ position: 'relative', maxWidth: '100%' }}
              >
                <div className="aptitude-test-form__block">
                  {ANSWER_TYPE.CHECKBOX === type && (
                    <CheckboxOrRadioGroup
                      name="answer"
                      type="radio"
                      options={options}
                      selectedOptions={values.answer}
                      controlFunc={handleChange}
                    />
                  )}
                  {ANSWER_TYPE.TEXT === type && (
                    <BasicInput
                      isValid={true}
                      content={values.answer}
                      name="answer"
                      controlFunc={handleChange}
                      s
                    />
                  )}
                  <ErrorMessage
                    name="answer"
                    render={message => (
                      <div className="form__error">{message}</div>
                    )}
                  />
                </div>

                <div className="aptitude-test-form__controls">
                  <BasicButtonGroup
                    groupStyles={{ justifyContent: 'flex-end' }}
                  >
                    <BasicButton
                      controlFunc={handleSubmit}
                      btnWidth={200}
                      btnHeight={42}
                      btnFontWeight={700}
                      btnArrow={false}
                      btnTextColor="#27282d"
                      btnText="Next Question"
                    />
                  </BasicButtonGroup>
                </div>
              </form>
            </PanelContainer>
          </>
        )
      }
    />
  );
};

AptitudeTestForm.propTypes = {
  type: PropTypes.oneOf(Object.values(ANSWER_TYPE)).isRequired,
  html: PropTypes.string,
  timestamp: PropTypes.number.isRequired,
  text: PropTypes.string,
  options: PropTypes.array,
  onSubmit: PropTypes.func,
  onTimeExpire: PropTypes.func,
};

export default AptitudeTestForm;
